const envExample = {
    name: '叮叮出行',
    logo: '/images/dingding-logo.jpg',
    AMap: {
        key: 'bc27782a976a8b04acceae25f1baa899'
    },
    isPosSwitch: false,//false不允许切换商户,true允许商户切换
}
export default envExample;
